<template>
  <section id="banner" aria-label="首頁焦點輪播">
    <v-carousel
      v-model="model"
      cycle
      interval="5000"
      height="auto"
      class="hero-carousel"
      :show-arrows="false"
      hide-delimiter-background
    >
      <v-carousel-item v-for="(item, i) in localObj" :key="i">
        <div
          class="hero"
          role="link"
          tabindex="0"
          :aria-label="item.Link ? `開啟：${t(item.Title)}` : t(item.Title)"
          @click="open(item.Link)"
          @keydown.enter="open(item.Link)"
        >
          <!-- A) 上方：圖片區 -->
          <div class="hero__media">
            <div class="hero__bg" :style="{ backgroundImage: `url(${item.Image})` }"></div>
            <div class="hero__scrim"></div>

            <!-- 右下角：進度點（固定在圖片右下） -->
            <div class="hero__progress" @click.stop aria-label="輪播進度">
              <button
                v-for="(_, idx) in localObj"
                :key="idx"
                type="button"
                class="prog-dot"
                :class="{ 'is-active': idx === model }"
                :aria-label="`切換到第 ${idx + 1} 則`"
                @click.stop="model = idx"
              />
            </div>

            <!-- 桌機疊字（保留原本設計） -->
            <div class="hero__content hero__content--desktop" @click.stop>
              <div class="hero__dot" aria-hidden="true"></div>

              <div class="hero__text">
                <h1 class="hero__title">{{ t(item.Title) }}</h1>
                <p class="hero__subtitle">{{ t(item.Desc) }}</p>

                <div class="hero__kicker" v-if="item.Tag || item.Date">
                  <span v-if="item.Tag">{{ t(item.Tag) }}</span>
                  <span v-if="item.Tag && item.Date" class="dot">•</span>
                  <span v-if="item.Date">{{ item.Date }}</span>
                </div>

                <!-- 桌機箭頭（維持你原本的樣子） -->
                <div class="hero__nav" @click.stop>
                  <button class="nav-btn" type="button" aria-label="上一則" @click.stop="prev">
                    <i class="fa-solid fa-chevron-left"></i>
                  </button>
                  <button class="nav-btn" type="button" aria-label="下一則" @click.stop="next">
                    <i class="fa-solid fa-chevron-right"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- B) 下方：手機資訊區（不擋圖） -->
          <section class="hero__panel" @click.stop aria-label="焦點資訊">
            <div class="panel__left">
              <h2 class="panel__title">{{ t(item.Title) }}</h2>
              <p class="panel__subtitle" v-if="item.Desc">{{ t(item.Desc) }}</p>

              <div class="panel__kicker" v-if="item.Tag || item.Date">
                <span v-if="item.Tag">{{ t(item.Tag) }}</span>
                <span v-if="item.Tag && item.Date" class="dot">•</span>
                <span v-if="item.Date">{{ item.Date }}</span>
              </div>
            </div>

            <div class="panel__right" @click.stop>
              <button class="nav-btn nav-btn--panel" type="button" aria-label="上一則" @click.stop="prev">
                <i class="fa-solid fa-chevron-left"></i>
              </button>
              <button class="nav-btn nav-btn--panel" type="button" aria-label="下一則" @click.stop="next">
                <i class="fa-solid fa-chevron-right"></i>
              </button>
            </div>
          </section>
        </div>
      </v-carousel-item>
    </v-carousel>
  </section>
</template>



<script>
import { mapState } from "vuex";
import axios from "axios";

export default {
  name: "BannerHero",
  data() {
    return {
      localObj: [],
      model: 0,
    };
  },
  computed: {
    ...mapState(["bannerPoolId", "siteSettingSuccess"]),
  },
  methods: {
    axi(url, method, callback) {
      axios({
        method,
        url,
        headers: { "Content-Type": "application/json" },
      })
        .then((res) => callback(res.data))
        .catch((err) => console.error(err));
    },
    getlocalData(response) {
      this.localObj = response?.Content || [];
      if (this.model > this.localObj.length - 1) this.model = 0;
    },
    open(link) {
      if (link) window.open(link, "_blank");
    },
    prev() {
      if (!this.localObj.length) return;
      this.model = this.model === 0 ? this.localObj.length - 1 : this.model - 1;
    },
    next() {
      if (!this.localObj.length) return;
      this.model = this.model === this.localObj.length - 1 ? 0 : this.model + 1;
    },
  },
  mounted() {
    if (this.siteSettingSuccess) {
      this.axi(
        `https://bulletin.dyu.edu.tw/BM/get_banner.php?id=${this.bannerPoolId}`,
        "get",
        this.getlocalData
      );
    }
  },
  watch: {
    siteSettingSuccess(val) {
      if (val) {
        this.axi(
          `https://bulletin.dyu.edu.tw/BM/get_banner.php?id=${this.bannerPoolId}`,
          "get",
          this.getlocalData
        );
      }
    },
  },
};
</script>

<style scoped lang="scss">
#banner {
  --hero-aspect: calc(420 / 1515);
  --brand: #1e5aa8;

  --pad-x: 36px;
  --pad-y: 28px;

  /* 桌機文字最大寬度 */
  --text-wrap: 60vw;
}

@media (max-width: 960px) {
  #banner { --pad-x: 22px; --pad-y: 18px; --text-wrap: 70vw; }
}

/* 不再用 Vuetify 預設 dots */
.hero-carousel {
  ::v-deep .v-carousel__controls { display: none !important; }
}

/* ===== 桌機 / 平板（預設） ===== */
.hero {
  position: relative;
  width: 100%;
  height: 0;
  padding-top: calc(100% * var(--hero-aspect));
  overflow: hidden;
  cursor: pointer;
}

.hero__bg {
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  transform: scale(1);
  transition: transform 650ms ease;
}
@media (hover: hover) and (pointer: fine) {
  .hero:hover .hero__bg { transform: scale(1.05); }
}

.hero__scrim {
  position: absolute;
  inset: 0;
  background:
    radial-gradient(820px 380px at 18% 74%, rgba(0,0,0,0.55), rgba(0,0,0,0) 62%),
    linear-gradient(to top, rgba(0,0,0,0.22) 0%, rgba(0,0,0,0.05) 45%, rgba(0,0,0,0) 75%);
}

.hero__content {
  position: absolute;
  left: 0;
  bottom: 0;
  padding: var(--pad-y) var(--pad-x);

  display: grid;
  grid-template-columns: 28px 1fr;
  gap: 14px;
  align-items: start;
}

.hero__dot {
  width: 22px;
  height: 22px;
  margin-top: 6px;
  border-radius: 999px;
  background: var(--brand);
  box-shadow:
    0 12px 28px rgba(0, 0, 0, 0.28),
    0 0 0 10px rgba(30, 90, 168, 0.18),
    0 0 0 20px rgba(30, 90, 168, 0.08);
}

.hero__text {
  max-width: var(--text-wrap);
  color: #fff;
  text-shadow: 0 2px 12px rgba(0,0,0,0.85);
  min-width: 0;
}

/* ✅ 中文更自然：避免 anywhere 亂拆 */
.hero__title {
  margin: 0;
  font-weight: 800;
  line-height: 1.12;
  letter-spacing: 0.01em;
  font-size: clamp(1.7rem, 3.1vw, 3.2rem);
  white-space: normal;
  word-break: keep-all;
  overflow-wrap: break-word;
}

.hero__subtitle {
  margin: 12px 0 0 0;
  font-size: clamp(1rem, 1.2vw, 1.15rem);
  line-height: 1.6;
  opacity: 0.95;

  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.hero__kicker {
  margin-top: 14px;
  font-size: 0.95rem;
  opacity: 0.92;
  letter-spacing: 0.02em;
  .dot { margin: 0 8px; opacity: 0.9; }
}

.hero__nav {
  margin-top: 10px;
  display: inline-flex;
  gap: 10px;
  align-items: center;
}

.nav-btn {
  width: 38px;
  height: 38px;
  border-radius: 999px;
  border: 1px solid rgba(255,255,255,0.35);
  background: rgba(0,0,0,0.15);
  color: #fff;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;
  transition: transform 160ms ease, background 160ms ease, border-color 160ms ease;
  outline: none;
}
.nav-btn i { font-size: 15px; line-height: 1; pointer-events: none; }
.nav-btn:hover {
  transform: translateY(-1px);
  background: rgba(0,0,0,0.30);
  border-color: rgba(255,255,255,0.55);
}

.hero__progress {
  position: absolute;
  right: 16px;
  bottom: 12px;
  display: inline-flex;
  gap: 8px;
  align-items: center;
  pointer-events: auto;
}

.prog-dot {
  width: 10px;
  height: 10px;
  border-radius: 999px;
  border: 1px solid rgba(255,255,255,0.45);
  background: rgba(255,255,255,0.12);
  padding: 0;
  cursor: pointer;
  outline: none;
}
.prog-dot.is-active {
  background: var(--brand);
  border-color: rgba(255,255,255,0.85);
  box-shadow: 0 0 0 4px rgba(30, 90, 168, 0.28);
}

@media (max-width: 600px) {
  /* 外層：改成上圖下文 */
  .hero {
    padding-top: 0 !important;
    height: auto !important;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  /* ====== 圖片區（上方） ====== */
  .hero__media {
    position: relative;
    width: 100%;
  }

  .hero__bg {
    position: relative !important;
    inset: auto !important;
    width: 100%;
    height: 220px;          /* 可調：200~260 */
    max-height: 260px;
    background-size: cover;
    background-position: center;
    transform: none !important;
    transition: none !important;
  }

  /* 手機不要疊遮罩（或想要淡淡也可以改 opacity） */
  .hero__scrim {
    display: none !important;
  }

  /* 手機不顯示桌機疊字區（避免擋圖） */
  .hero__content--desktop {
    display: none !important;
  }

  /* ====== 進度點：固定在圖片右下角 ====== */
  .hero__progress {
    position: absolute !important;
    right: 12px;
    bottom: 10px;           /* 直接貼在圖片右下 */
    top: auto !important;
    display: inline-flex;
    gap: 7px;
    z-index: 5;
  }

  .prog-dot {
    width: 10px;
    height: 10px;
    border-radius: 999px;
    border: 1px solid rgba(255,255,255,0.40);
    background: rgba(255,255,255,0.20);
    padding: 0;
  }

  .prog-dot.is-active {
    background: #ffffff;
    border-color: rgba(255,255,255,0.95);
    box-shadow: 0 0 0 4px rgba(255,255,255,0.16);
  }

  /* ====== 圖片下方：資訊區（section） ====== */
  .hero__panel {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 96px; /* 左文字 / 右箭頭 */
    gap: 14px;
    align-items: center;

    padding: 18px 16px 22px;
    background:
      radial-gradient(520px 220px at 20% 10%, rgba(255,255,255,0.14), rgba(255,255,255,0) 60%),
      linear-gradient(135deg, #1e5aa8 0%, #0f356a 100%);
    color: #fff;
  }

  .panel__left {
    min-width: 0;
  }

  .panel__title {
    margin: 0;
    font-size: 1.55rem;
    font-weight: 800;
    line-height: 1.22;
    letter-spacing: 0.01em;

    /* 中文自然斷行 */
    word-break: keep-all;
    overflow-wrap: break-word;
  }

  .panel__subtitle {
    margin: 10px 0 0 0;
    font-size: 0.95rem;
    line-height: 1.6;
    opacity: 0.92;

    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .panel__kicker {
    margin-top: 10px;
    padding-top: 8px;
    border-top: 1px solid rgba(255,255,255,0.22);
    font-size: 0.85rem;
    opacity: 0.88;

    .dot { margin: 0 8px; opacity: 0.9; }
  }

  /* ====== 右側箭頭（兩顆橫排也可；你要直排就改 flex-direction） ====== */
  .panel__right {
    display: flex;
    flex-direction: row;  
    align-items: flex-end;
    justify-content: center;
    gap: 12px;
  }

  /* 面板用的箭頭按鈕：比桌機更乾淨 */
  .nav-btn--panel {
    width: 44px;
    height: 44px;
    border-radius: 999px;
    border: 1px solid rgba(255,255,255,0.35);
    background: rgba(255,255,255,0.12);
    color: #fff;

    display: flex;
    align-items: center;
    justify-content: center;
  }

  .nav-btn--panel i {
    font-size: 16px;
    line-height: 1;
    pointer-events: none;
  }

  .nav-btn--panel:active {
    transform: scale(0.97);
    background: rgba(255,255,255,0.18);
  }
}

</style>
